<div class="portada video">
  <div id="wrapVideo" class="video-container">
    <div class="overlay"></div>
    <div id="bkVideo"></div>
  </div>
</div>